// // src/pages/artisan/messages/ArtisanMessages.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import './artisanmessages.scss';
// import withAuth from '../../auth/WithAuth';
// import Sidebar from '../../../components/layout/Sidebar';
// import { serverUrlAuth } from '../../../serverUrl';
// import { toast } from 'react-toastify';

// import {
//   FaSearch,
//   FaUserCircle,
//   FaComments,
//   FaPaperPlane,
//   FaArrowLeft,
//   FaClock,
//   FaImage,
//   FaCheck,
//   FaHandshake,
//   FaMoneyBillWave,
//   FaTimes,
//   FaFlag,
//   FaEdit,
//   FaCamera,
// } from 'react-icons/fa';

// import { useLocation, useNavigate } from 'react-router-dom';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';

// const ArtisanMessages = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const queryParams = new URLSearchParams(location.search);
//   const preselectedProposalId = queryParams.get('proposal');

//   // ============================================================
//   // STATE
//   // ============================================================
//   const [conversations, setConversations] = useState([]);
//   const [selectedConversation, setSelectedConversation] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState('');

//   const [loading, setLoading] = useState(true);
//   const [isSending, setIsSending] = useState(false);

//   const [isLoadingChat, setIsLoadingChat] = useState(false);

//   // ✅ NEW:
//   // Only true once fetchMessages has actually completed for the
//   // current conversation. Until then, the "No messages yet" branch
//   // is not reachable, so a premature isLoadingChat flip cannot
//   // produce the flash.
//   const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

//   const [searchTerm, setSearchTerm] = useState('');
//   const [showSidebar, setShowSidebar] = useState(true);

//   const [negotiationDetails, setNegotiationDetails] = useState(null);
//   const [currentProjectId, setCurrentProjectId] = useState(null);

//   const [messageType, setMessageType] = useState('chat');
//   const [progressPercentage, setProgressPercentage] = useState('');
//   const [milestoneNote, setMilestoneNote] = useState('');

//   const [selectedImages, setSelectedImages] = useState([]);
//   const [imagePreviewUrls, setImagePreviewUrls] = useState([]);

//   const fileInputRef = useRef(null);

//   const [showFinalAgreementModal, setShowFinalAgreementModal] = useState(false);
//   const [finalAgreementAmount, setFinalAgreementAmount] = useState('');
//   const [isSubmittingFinalAgreement, setIsSubmittingFinalAgreement] =
//     useState(false);

//   const [showEditFinalAgreementModal, setShowEditFinalAgreementModal] =
//     useState(false);
//   const [editFinalAgreementAmount, setEditFinalAgreementAmount] = useState('');
//   const [isEditingFinalAgreement, setIsEditingFinalAgreement] = useState(false);
//   const [editAgreementNote, setEditAgreementNote] = useState('');

//   const [showImageViewer, setShowImageViewer] = useState(false);
//   const [selectedImageForView, setSelectedImageForView] = useState(null);

//   const messagesEndRef = useRef(null);
//   const messageIntervalRef = useRef(null);
//   const messagesContainerRef = useRef(null);
//   const isPollingRef = useRef(false);

//   const activeProposalRef = useRef(null);
//   const activeProjectRef = useRef(null);

//   const conversationTokenRef = useRef(0);
//   const abortControllerRef = useRef(null);

//   // ============================================================
//   // DERIVED STATE
//   // ============================================================
//   const isNegotiationActive = negotiationDetails?.is_selected === true;

//   const isNegotiationClosed =
//     !isNegotiationActive && negotiationDetails?.is_closed === true;

//   const isChatDisabled = isNegotiationClosed;

//   const isNegotiationPhase = !isNegotiationActive && !isNegotiationClosed;

//   const isMilestoneComplete =
//     messageType === 'milestone' &&
//     parseInt(progressPercentage, 10) === 100;

//   const hasPendingAgreement =
//     negotiationDetails?.pending_final_amount &&
//     !negotiationDetails?.final_agreed_amount;

//   const safeMessages = Array.isArray(messages) ? messages : [];

//   // ============================================================
//   // MESSAGE NORMALIZER
//   // ============================================================
//   const normalizeMessages = (data, fallbackSource = 'negotiation') => {
//     let rawMessages = [];

//     if (Array.isArray(data)) {
//       rawMessages = data;
//     } else if (Array.isArray(data?.conversation)) {
//       rawMessages = data.conversation;
//     } else if (Array.isArray(data?.messages)) {
//       rawMessages = data.messages;
//     }

//     return rawMessages.map((msg) => ({
//       ...msg,
//       id: msg.id,
//       message: msg.message || msg.content || '',
//       timestamp: msg.timestamp || msg.created_at,
//       sender_role: msg.sender_role,
//       sender_name: msg.sender_name,
//       sender_id: msg.sender_id || msg.sender,
//       read_by_client: msg.read_by_client,
//       read_by_artisan: msg.read_by_artisan,
//       type: msg.type || 'chat',
//       source: msg.source || fallbackSource,
//       negotiation_id:
//         msg.negotiation_id || msg.negotiation || data?.negotiation || null,
//     }));
//   };

//   // ============================================================
//   // BODY CLASS
//   // ============================================================
//   useEffect(() => {
//     document.body.classList.add('artisan-messages-active');
//     return () => {
//       document.body.classList.remove('artisan-messages-active');
//     };
//   }, []);

//   // ============================================================
//   // CAMERA
//   // ============================================================
//   const handleCameraCapture = () => {
//     const cameraInput = document.createElement('input');
//     cameraInput.type = 'file';
//     cameraInput.accept = 'image/*';
//     cameraInput.capture = 'environment';
//     cameraInput.multiple = false;

//     cameraInput.onchange = (e) => {
//       const files = Array.from(e.target.files || []);
//       if (files.length > 0) {
//         setSelectedImages((prev) => [...prev, ...files]);
//         setImagePreviewUrls((prev) => [
//           ...prev,
//           ...files.map((file) => URL.createObjectURL(file)),
//         ]);
//         toast.success('📸 Photo captured successfully!');
//       }
//       if (document.body.contains(cameraInput)) {
//         document.body.removeChild(cameraInput);
//       }
//     };

//     cameraInput.oncancel = () => {
//       if (document.body.contains(cameraInput)) {
//         document.body.removeChild(cameraInput);
//       }
//     };

//     document.body.appendChild(cameraInput);
//     cameraInput.click();
//   };

//   // ============================================================
//   // MARK CONVERSATION AS READ
//   // ============================================================
//   const markConversationAsRead = async (
//     projectId,
//     negotiationId,
//     refreshInbox = true,
//   ) => {
//     if (!projectId || !negotiationId) return;

//     try {
//       await serverUrlAuth.post(
//         `/updates/mark-messages-as-read/${projectId}/${negotiationId}/mark-all-read/`,
//       );

//       if (refreshInbox) {
//         const convResponse = await serverUrlAuth.get('negotiations/inbox/');
//         setConversations(
//           Array.isArray(convResponse.data) ? convResponse.data : [],
//         );
//       }
//     } catch (err) {
//       console.error(
//         'Error marking conversation as read:',
//         err.response?.data || err,
//       );
//     }
//   };

//   // ============================================================
//   // PROPOSAL DETAILS
//   // ============================================================
//   const fetchProposalDetails = async (proposalId) => {
//     if (!proposalId) return null;
//     try {
//       const response = await serverUrlAuth.get(
//         `proposals/proposal-detail/${proposalId}/`,
//       );
//       return response.data;
//     } catch (err) {
//       console.error('Error fetching proposal details:', err);
//       return null;
//     }
//   };

//   // ============================================================
//   // NEGOTIATION DETAILS
//   // ============================================================
//   const fetchNegotiationDetails = async (proposalId) => {
//     if (!proposalId) return null;

//     try {
//       const response = await serverUrlAuth.get(
//         `negotiations/proposal/${proposalId}/`,
//       );

//       if (
//         activeProposalRef.current &&
//         String(activeProposalRef.current) !== String(proposalId)
//       ) {
//         return null;
//       }

//       setNegotiationDetails(response.data);

//       return response.data;
//     } catch (err) {
//       console.error('Error fetching negotiation details:', err);
//       return null;
//     }
//   };

//   // ============================================================
//   // FETCH MESSAGES
//   // ============================================================
//   const fetchMessages = async (
//     projectId,
//     proposalId,
//     isInitialLoad = false,
//     token = null,
//   ) => {
//     if (!projectId || !proposalId) {
//       if (isInitialLoad) {
//         setIsLoadingChat(false);
//         setHasLoadedOnce(true);
//       }
//       return;
//     }

//     const myToken =
//       token !== null ? token : conversationTokenRef.current;

//     if (
//       activeProjectRef.current &&
//       String(activeProjectRef.current) !== String(projectId)
//     ) {
//       if (isInitialLoad) {
//         setIsLoadingChat(false);
//         setHasLoadedOnce(true);
//       }
//       return;
//     }

//     try {
//       let rawMessages = [];

//       if (isNegotiationActive) {
//         const response = await serverUrlAuth.get(
//           `/updates/messages/${projectId}/`,
//           { signal: abortControllerRef.current?.signal },
//         );

//         if (conversationTokenRef.current !== myToken) return;

//         rawMessages = Array.isArray(response.data?.conversation)
//           ? response.data.conversation
//           : Array.isArray(response.data)
//           ? response.data
//           : [];
//       } else {
//         const response = await serverUrlAuth.get(
//           `negotiations/proposal/${proposalId}/messages/`,
//           { signal: abortControllerRef.current?.signal },
//         );

//         if (conversationTokenRef.current !== myToken) return;

//         rawMessages = Array.isArray(response.data)
//           ? response.data
//           : Array.isArray(response.data?.messages)
//           ? response.data.messages
//           : [];
//       }

//       if (conversationTokenRef.current !== myToken) return;

//       const processed = normalizeMessages(
//         rawMessages,
//         isNegotiationActive ? 'project' : 'negotiation',
//       ).sort((a, b) => {
//         const dateA = new Date(a.timestamp || 0).getTime();
//         const dateB = new Date(b.timestamp || 0).getTime();
//         return dateA - dateB;
//       });

//       // ✅ ATOMIC SWAP — same synchronous block, one render
//       if (isInitialLoad) {
//         setMessages(processed);
//         setIsLoadingChat(false);
//         setHasLoadedOnce(true);
//         setTimeout(scrollToBottom, 0);
//       } else {
//         setMessages(processed);
//         maybeScrollToBottom();
//       }
//     } catch (err) {
//       if (
//         err.name === 'CanceledError' ||
//         err.code === 'ERR_CANCELED'
//       ) {
//         return;
//       }

//       if (conversationTokenRef.current !== myToken) return;

//       console.error(
//         'Error fetching messages:',
//         err.response?.data || err,
//       );

//       if (isInitialLoad) {
//         setTimeout(() => {
//           if (conversationTokenRef.current === myToken) {
//             setMessages([]);
//             setIsLoadingChat(false);
//             setHasLoadedOnce(true);
//           }
//         }, 800);
//         toast.error('Failed to load messages');
//       }
//     }
//   };

//   // ============================================================
//   // FETCH CONVERSATIONS
//   // ============================================================
//   const fetchConversations = async () => {
//     try {
//       const response = await serverUrlAuth.get('negotiations/inbox/');
//       const inboxData = Array.isArray(response.data) ? response.data : [];
//       setConversations(inboxData);

//       if (preselectedProposalId && !selectedConversation) {
//         const conversation = inboxData.find(
//           (c) => c.proposal?.toString() === preselectedProposalId.toString(),
//         );

//         if (conversation) {
//           await handleSelectConversation(conversation, true);
//         } else {
//           await fetchSingleConversation(preselectedProposalId);
//         }
//       }
//     } catch (err) {
//       console.error('Error fetching conversations:', err);
//       toast.error('Failed to load conversations');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ============================================================
//   // FETCH SINGLE CONVERSATION (deep link)
//   // ============================================================
//   const fetchSingleConversation = async (proposalId) => {
//     if (!proposalId) return;

//     stopPolling();
//     if (abortControllerRef.current) {
//       abortControllerRef.current.abort();
//       abortControllerRef.current = null;
//     }

//     conversationTokenRef.current += 1;
//     const myToken = conversationTokenRef.current;

//     setIsLoadingChat(true);
//     setHasLoadedOnce(false);   // ✅ reset
//     setMessages([]);
//     setNegotiationDetails(null);

//     try {
//       const response = await serverUrlAuth.get(
//         `negotiations/proposal/${proposalId}/`,
//       );

//       if (conversationTokenRef.current !== myToken) return;

//       const convData = response.data;
//       const projectId = convData.proposal_details?.project;
//       const negotiationId = convData.id;

//       const newConversation = {
//         id: negotiationId,
//         proposal: proposalId,
//         project_id: projectId,
//         project_title: convData.project_title,
//         artisan_name: convData.artisan_name,
//         client_name: convData.client_name,
//         last_message_time: convData.created_at,
//         unread_count: 0,
//         is_closed: convData.is_closed,
//         is_selected: convData.is_selected,
//       };

//       activeProposalRef.current = proposalId;
//       activeProjectRef.current = projectId;

//       setCurrentProjectId(projectId);
//       setSelectedConversation(newConversation);
//       setShowSidebar(false);
//       setNegotiationDetails(convData);

//       abortControllerRef.current = new AbortController();

//       await fetchProposalDetails(proposalId);
//       await fetchMessages(projectId, proposalId, true, myToken);

//       if (conversationTokenRef.current !== myToken) return;

//       if (negotiationId) {
//         await markConversationAsRead(projectId, negotiationId, true);
//       }
//     } catch (err) {
//       if (conversationTokenRef.current !== myToken) return;
//       console.error('Error fetching single conversation:', err);
//       toast.error('Could not open conversation');

//       setTimeout(() => {
//         if (conversationTokenRef.current === myToken) {
//           setIsLoadingChat(false);
//           setHasLoadedOnce(true);
//         }
//       }, 1500);
//     }
//   };

//   // ============================================================
//   // SELECT CONVERSATION
//   // ============================================================
//   const handleSelectConversation = async (
//     conversation,
//     fromPreselection = false,
//   ) => {
//     const projectId =
//       conversation.proposal_details?.project || conversation.project_id;
//     const proposalId = conversation.proposal;
//     const conversationNegotiationId =
//       conversation.id || conversation.negotiation;

//     if (!proposalId) {
//       toast.error('This conversation has no proposal ID');
//       return;
//     }

//     if (!projectId) {
//       toast.error('This conversation has no project ID');
//       return;
//     }

//     stopPolling();
//     if (abortControllerRef.current) {
//       abortControllerRef.current.abort();
//       abortControllerRef.current = null;
//     }

//     conversationTokenRef.current += 1;
//     const myToken = conversationTokenRef.current;

//     setIsLoadingChat(true);
//     setHasLoadedOnce(false);   // ✅ reset
//     setMessages([]);
//     setCurrentProjectId(projectId);
//     setSelectedConversation(conversation);
//     setShowSidebar(false);
//     setNewMessage('');
//     setProgressPercentage('');
//     setMilestoneNote('');
//     clearImages();
//     setNegotiationDetails(null);

//     activeProposalRef.current = proposalId;
//     activeProjectRef.current = projectId;

//     if (!fromPreselection) {
//       const params = new URLSearchParams(location.search);
//       params.set('proposal', proposalId);
//       navigate(`${location.pathname}?${params.toString()}`, {
//         replace: true,
//       });
//     }

//     try {
//       abortControllerRef.current = new AbortController();

//       await fetchProposalDetails(proposalId);

//       const negotiation = await fetchNegotiationDetails(proposalId);

//       if (conversationTokenRef.current !== myToken) return;

//       const negotiationId = negotiation?.id || conversationNegotiationId;

//       if (!negotiationId) {
//         toast.error('Negotiation ID not available');
//         setTimeout(() => {
//           if (conversationTokenRef.current === myToken) {
//             setIsLoadingChat(false);
//             setHasLoadedOnce(true);
//           }
//         }, 800);
//         return;
//       }

//       await fetchMessages(projectId, proposalId, true, myToken);

//       if (conversationTokenRef.current !== myToken) return;

//       await markConversationAsRead(projectId, negotiationId, true);
//     } catch (err) {
//       if (conversationTokenRef.current !== myToken) return;
//       console.error('Error selecting conversation:', err);
//       toast.error('Could not load conversation');

//       setTimeout(() => {
//         if (conversationTokenRef.current === myToken) {
//           setIsLoadingChat(false);
//           setHasLoadedOnce(true);
//         }
//       }, 1500);
//     }
//   };

//   // ============================================================
//   // IMAGE SELECTION
//   // ============================================================
//   const handleImageSelect = (e) => {
//     const files = Array.from(e.target.files || []);
//     const validFiles = files.filter((file) =>
//       file.type.startsWith('image/'),
//     );

//     setSelectedImages((prev) => [...prev, ...validFiles]);
//     setImagePreviewUrls((prev) => [
//       ...prev,
//       ...validFiles.map((file) => URL.createObjectURL(file)),
//     ]);

//     e.target.value = '';
//   };

//   const removeSelectedImage = (index) => {
//     if (imagePreviewUrls[index]) {
//       URL.revokeObjectURL(imagePreviewUrls[index]);
//     }
//     setSelectedImages((prev) => prev.filter((_, i) => i !== index));
//     setImagePreviewUrls((prev) => prev.filter((_, i) => i !== index));
//   };

//   const clearImages = () => {
//     imagePreviewUrls.forEach((url) => URL.revokeObjectURL(url));
//     setSelectedImages([]);
//     setImagePreviewUrls([]);
//   };

//   // ============================================================
//   // SEND MESSAGE
//   // ============================================================
//   const sendMessage = async () => {
//     if (isChatDisabled) {
//       toast.info('This conversation is closed.');
//       return;
//     }

//     if (!selectedConversation?.proposal) {
//       toast.error('No conversation selected');
//       return;
//     }

//     if (isNegotiationActive && messageType === 'milestone') {
//       if (!milestoneNote.trim()) {
//         toast.error('Please add a note for the milestone');
//         return;
//       }
//       if (
//         !progressPercentage ||
//         Number(progressPercentage) < 0 ||
//         Number(progressPercentage) > 100
//       ) {
//         toast.error('Please enter a valid progress percentage (0-100)');
//         return;
//       }
//     } else if (!newMessage.trim() && selectedImages.length === 0) {
//       toast.error('Please enter a message or attach an image');
//       return;
//     }

//     setIsSending(true);

//     const myToken = conversationTokenRef.current;

//     try {
//       let response;

//       if (isNegotiationActive && currentProjectId) {
//         const formData = new FormData();
//         const isMilestoneMsg = messageType === 'milestone';
//         const isMilestoneCompleteLocal =
//           isMilestoneMsg && parseInt(progressPercentage, 10) === 100;

//         formData.append('type', isMilestoneMsg ? 'milestone' : 'chat');

//         if (isMilestoneMsg) {
//           formData.append('progress_percentage', progressPercentage);
//           formData.append('note', milestoneNote);
//         } else {
//           formData.append('message', newMessage.trim() || '📷 Image attached');
//         }

//         selectedImages.forEach((image) => {
//           formData.append('uploaded_images', image);
//         });

//         response = await serverUrlAuth.post(
//           `/updates/post-updates/${currentProjectId}/`,
//           formData,
//           { headers: { 'Content-Type': 'multipart/form-data' } },
//         );

//         if (isMilestoneCompleteLocal) {
//           const paymentMessage = `🎉 Your product is ready. To proceed with delivery, kindly complete the final payment. Delivery will begin as soon as your payment is confirmed.`;

//           await serverUrlAuth.post(
//             `/updates/post-updates/${currentProjectId}/`,
//             { type: 'chat', message: paymentMessage },
//             { headers: { 'Content-Type': 'application/json' } },
//           );

//           toast.success(
//             '🎉 Project marked as complete! Payment notification sent to client.',
//           );
//         }

//         setProgressPercentage('');
//         setMilestoneNote('');
//       } else {
//         const proposalId = selectedConversation.proposal;
//         const formData = new FormData();

//         formData.append('message', newMessage.trim() || '📷 Image attached');

//         selectedImages.forEach((image) => {
//           formData.append('images', image);
//         });

//         response = await serverUrlAuth.post(
//           `negotiations/proposal/${proposalId}/messages/`,
//           formData,
//           { headers: { 'Content-Type': 'multipart/form-data' } },
//         );
//       }

//       setNewMessage('');
//       clearImages();

//       if (conversationTokenRef.current === myToken) {
//         await fetchMessages(
//           currentProjectId,
//           selectedConversation.proposal,
//           false,
//           myToken,
//         );
//       }

//       const convResponse = await serverUrlAuth.get('negotiations/inbox/');

//       if (conversationTokenRef.current === myToken) {
//         setConversations(
//           Array.isArray(convResponse.data) ? convResponse.data : [],
//         );
//       }
//     } catch (err) {
//       console.error('Failed to send message:', err.response?.data || err);
//       toast.error('Failed to send message.');
//     } finally {
//       setIsSending(false);
//     }
//   };

//   // ============================================================
//   // SUBMIT FINAL AGREEMENT
//   // ============================================================
//   const handleSubmitFinalAgreement = async () => {
//     if (
//       !finalAgreementAmount ||
//       !selectedConversation ||
//       !negotiationDetails
//     )
//       return;

//     if (Number(finalAgreementAmount) <= 0) {
//       toast.error('Please enter a valid amount');
//       return;
//     }

//     const proposalId = selectedConversation.proposal;
//     if (!proposalId) {
//       toast.error('No proposal selected');
//       return;
//     }
//     if (!negotiationDetails.id) {
//       toast.error('Negotiation details not available');
//       return;
//     }

//     setIsSubmittingFinalAgreement(true);

//     try {
//       await serverUrlAuth.patch(
//         `negotiations/submit-final-agreement/${negotiationDetails.id}/`,
//         { final_agreed_amount: finalAgreementAmount },
//       );

//       toast.success(
//         'Final agreement submitted! Waiting for client acceptance.',
//       );

//       setShowFinalAgreementModal(false);
//       setFinalAgreementAmount('');

//       await fetchNegotiationDetails(proposalId);
//       await fetchMessages(
//         currentProjectId,
//         proposalId,
//         false,
//         conversationTokenRef.current,
//       );
//     } catch (err) {
//       console.error('Error submitting final agreement:', err);
//       toast.error('Failed to submit final agreement');
//     } finally {
//       setIsSubmittingFinalAgreement(false);
//     }
//   };

//   // ============================================================
//   // EDIT FINAL AGREEMENT
//   // ============================================================
//   const handleEditFinalAgreement = async () => {
//     if (
//       !editFinalAgreementAmount ||
//       Number(editFinalAgreementAmount) <= 0
//     ) {
//       toast.error('Please enter a valid amount');
//       return;
//     }

//     if (!selectedConversation?.proposal) {
//       toast.error('No proposal selected');
//       return;
//     }

//     if (!negotiationDetails?.id) {
//       toast.error('Negotiation details not available');
//       return;
//     }

//     setIsEditingFinalAgreement(true);

//     try {
//       const proposalId = selectedConversation.proposal;

//       await serverUrlAuth.patch(
//         `negotiations/submit-final-agreement/${negotiationDetails.id}/`,
//         { final_agreed_amount: editFinalAgreementAmount },
//       );

//       toast.success('Final agreement amount updated successfully!');

//       setShowEditFinalAgreementModal(false);
//       setEditFinalAgreementAmount('');

//       const note = editAgreementNote.trim();
//       setEditAgreementNote('');

//       await fetchNegotiationDetails(proposalId);

//       if (note) {
//         await serverUrlAuth.post(
//           `negotiations/proposal/${proposalId}/messages/`,
//           { message: `📝 Note about updated agreement: ${note}` },
//         );
//       }

//       await fetchMessages(
//         currentProjectId,
//         proposalId,
//         false,
//         conversationTokenRef.current,
//       );

//       const convResponse = await serverUrlAuth.get('negotiations/inbox/');
//       setConversations(
//         Array.isArray(convResponse.data) ? convResponse.data : [],
//       );
//     } catch (err) {
//       console.error('Error updating final agreement:', err);
//       toast.error('Failed to update final agreement');
//     } finally {
//       setIsEditingFinalAgreement(false);
//     }
//   };

//   // ============================================================
//   // SCROLL HELPERS
//   // ============================================================
//   const scrollToBottom = () => {
//     setTimeout(() => {
//       if (messagesContainerRef.current) {
//         messagesContainerRef.current.scrollTop =
//           messagesContainerRef.current.scrollHeight;
//       }
//     }, 100);
//   };

//   const maybeScrollToBottom = () => {
//     setTimeout(() => {
//       const el = messagesContainerRef.current;
//       if (!el) return;

//       const distanceFromBottom =
//         el.scrollHeight - el.scrollTop - el.clientHeight;

//       if (distanceFromBottom < 120) {
//         el.scrollTop = el.scrollHeight;
//       }
//     }, 50);
//   };

//   // ============================================================
//   // POLLING
//   // ============================================================
//   const startPolling = () => {
//     if (messageIntervalRef.current) clearInterval(messageIntervalRef.current);

//     messageIntervalRef.current = setInterval(async () => {
//       if (isNegotiationClosed) return;
//       if (
//         !selectedConversation ||
//         !currentProjectId ||
//         isPollingRef.current
//       )
//         return;

//       const myToken = conversationTokenRef.current;

//       isPollingRef.current = true;

//       try {
//         const proposalId = selectedConversation.proposal;
//         if (!proposalId) return;

//         const negotiation = await fetchNegotiationDetails(proposalId);

//         if (conversationTokenRef.current !== myToken) return;

//         const negotiationId = negotiation?.id || selectedConversation.id;

//         await fetchMessages(
//           currentProjectId,
//           proposalId,
//           false,
//           myToken,
//         );

//         if (conversationTokenRef.current !== myToken) return;

//         await markConversationAsRead(
//           currentProjectId,
//           negotiationId,
//           false,
//         );

//         const convResponse = await serverUrlAuth.get('negotiations/inbox/');

//         if (conversationTokenRef.current !== myToken) return;

//         setConversations(
//           Array.isArray(convResponse.data) ? convResponse.data : [],
//         );
//       } catch (error) {
//         if (
//           error.name === 'CanceledError' ||
//           error.code === 'ERR_CANCELED'
//         ) {
//           return;
//         }
//         console.error('Polling error:', error.response?.data || error);
//       } finally {
//         isPollingRef.current = false;
//       }
//     }, 5000);
//   };

//   const stopPolling = () => {
//     if (messageIntervalRef.current) {
//       clearInterval(messageIntervalRef.current);
//       messageIntervalRef.current = null;
//     }
//     isPollingRef.current = false;
//   };

//   // ============================================================
//   // FILTER / FORMAT
//   // ============================================================
//   const filteredConversations = Array.isArray(conversations)
//     ? conversations.filter(
//         (conv) =>
//           conv.client_name
//             ?.toLowerCase()
//             .includes(searchTerm.toLowerCase()) ||
//           conv.project_title
//             ?.toLowerCase()
//             .includes(searchTerm.toLowerCase()),
//       )
//     : [];

//   const formatTime = (timestamp) => {
//     if (!timestamp) return '';
//     const date = new Date(timestamp);
//     const now = new Date();
//     const diff = now - date;
//     const hours = Math.floor(diff / (1000 * 60 * 60));

//     if (hours < 1) {
//       const mins = Math.floor(diff / (1000 * 60));
//       return mins === 0 ? 'Just now' : `${mins} min ago`;
//     }
//     if (hours < 24) {
//       return date.toLocaleTimeString([], {
//         hour: '2-digit',
//         minute: '2-digit',
//       });
//     }
//     if (hours < 48) return 'Yesterday';
//     return date.toLocaleDateString();
//   };

//   const formatMessageTime = (timestamp) => {
//     if (!timestamp) return '';
//     return new Date(timestamp).toLocaleTimeString([], {
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   const getUnreadCount = (conversation) => conversation?.unread_count || 0;

//   const getDisplayName = (conversation) =>
//     conversation?.client_name || 'Client';

//   const handleBackToDashboard = () => {
//     navigate('/artisan-dashboard');
//   };

//   // ============================================================
//   // EFFECTS
//   // ============================================================
//   useEffect(() => {
//     fetchConversations();
//     return () => stopPolling();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     if (
//       selectedConversation &&
//       currentProjectId &&
//       !isNegotiationClosed &&
//       !isLoadingChat
//     ) {
//       startPolling();
//     } else {
//       stopPolling();
//     }
//     return () => stopPolling();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     selectedConversation,
//     currentProjectId,
//     isNegotiationActive,
//     isNegotiationClosed,
//     isLoadingChat,
//   ]);

//   useEffect(() => {
//     return () => {
//       imagePreviewUrls.forEach((url) => URL.revokeObjectURL(url));
//     };
//   }, [imagePreviewUrls]);

//   // ============================================================
//   // LOADING
//   // ============================================================
//   if (loading) {
//     return (
//       <>
//         <Sidebar />
//         <div className="modern-dashboard artisan-messages-page hide-nav-mobile">
//           <div className="dashboard-loader">
//             <div className="wooden-spinner"></div>
//             <p>Loading conversations...</p>
//           </div>
//         </div>
//       </>
//     );
//   }

//   // ============================================================
//   // RENDER
//   // ============================================================
//   return (
//     <>
//       <Sidebar />

//       <div className="modern-dashboard artisan-messages-page hide-nav-mobile">
//         <div className="messages-container-modern">
//           {/* CONVERSATIONS SIDEBAR */}
//           <div
//             className={`conversations-sidebar-modern ${
//               showSidebar ? 'open' : 'closed'
//             }`}
//           >
//             <div className="sidebar-header-modern">
//               <div className="search-bar-modern">
//                 <button
//                   type="button"
//                   className="mobile-back-btn-modern"
//                   onClick={handleBackToDashboard}
//                   aria-label="Back to dashboard"
//                 >
//                   <FaArrowLeft />
//                 </button>

//                 <FaSearch className="search-icon-modern" />

//                 <input
//                   type="text"
//                   placeholder="Search clients..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//               </div>
//             </div>

//             <div className="conversations-list-modern">
//               {filteredConversations.length === 0 ? (
//                 <div className="empty-state-modern">
//                   <div className="empty-icon-modern">💬</div>
//                   <h4>No conversations yet</h4>
//                   <p>When clients message you, they'll appear here.</p>
//                 </div>
//               ) : (
//                 filteredConversations.map((conv) => {
//                   const unreadCount = getUnreadCount(conv);
//                   return (
//                     <div
//                       key={conv.id}
//                       className={`conversation-item-modern ${
//                         selectedConversation?.id === conv.id ? 'active' : ''
//                       } ${conv.is_closed ? 'closed' : ''}`}
//                       onClick={() => handleSelectConversation(conv)}
//                     >
//                       <div className="avatar-modern">
//                         <FaUserCircle />
//                       </div>

//                       <div className="conversation-info-modern">
//                         <div className="conversation-header-modern">
//                           <h4>{getDisplayName(conv)}</h4>
//                           <span className="timestamp-modern">
//                             {formatTime(conv.last_message_time)}
//                           </span>
//                         </div>

//                         <div className="conversation-preview-modern">
//                           <p className="project-title-modern">
//                             {conv.project_title}
//                           </p>
//                           {conv.is_closed && (
//                             <span className="closed-badge-mini">
//                               🔒 Closed
//                             </span>
//                           )}
//                         </div>
//                       </div>

//                       {unreadCount > 0 && (
//                         <div className="unread-badge-modern">
//                           {unreadCount}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })
//               )}
//             </div>
//           </div>

//           {/* CHAT AREA */}
//           <div className="chat-area-modern">
//             {!selectedConversation ? (
//               <div className="no-conversation-selected-modern">
//                 <div className="no-chat-icon-modern">
//                   <FaComments />
//                 </div>
//                 <h3>Select a conversation</h3>
//                 <p>Choose a chat from the list to start messaging</p>
//                 <button
//                   className="back-to-chats-btn-modern"
//                   onClick={() => setShowSidebar(true)}
//                 >
//                   Back to Chats
//                 </button>
//               </div>
//             ) : (
//               <>
//                 {/* CHAT HEADER */}
//                 <div className="chat-header-modern">
//                   <button
//                     className="back-button-modern"
//                     onClick={() => {
//                       stopPolling();
//                       if (abortControllerRef.current) {
//                         abortControllerRef.current.abort();
//                         abortControllerRef.current = null;
//                       }
//                       conversationTokenRef.current += 1;

//                       setIsLoadingChat(false);
//                       setHasLoadedOnce(false);
//                       setShowSidebar(true);
//                       setSelectedConversation(null);
//                       setMessages([]);
//                       setCurrentProjectId(null);
//                       setNegotiationDetails(null);
//                       activeProposalRef.current = null;
//                       activeProjectRef.current = null;
//                       navigate(location.pathname, { replace: true });
//                     }}
//                   >
//                     <FaArrowLeft />
//                   </button>

//                   <div className="chat-user-info-modern">
//                     <div className="user-avatar-modern">
//                       <FaUserCircle />
//                     </div>
//                     <div className="user-details-modern">
//                       <h3>{getDisplayName(selectedConversation)}</h3>
//                       <p className="project-context-modern">
//                         Project: {selectedConversation.project_title}
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 {/* STATUS BANNER */}
//                 {isNegotiationActive ? (
//                   <div className="status-banner-modern success">
//                     <FaCheck className="status-icon" />
//                     <span>Project In Progress</span>
//                     <small>
//                       Send updates and milestones to keep the client informed
//                     </small>
//                   </div>
//                 ) : isNegotiationClosed ? (
//                   <div className="status-banner-modern closed">
//                     <FaTimes className="status-icon" />
//                     <span>Negotiation Closed</span>
//                     <small>
//                       Another artisan was selected for this project.
//                     </small>
//                   </div>
//                 ) : (
//                   negotiationDetails && (
//                     <div className="status-banner-modern info">
//                       {negotiationDetails.final_agreed_amount ? (
//                         <>
//                           <FaHandshake />
//                           <span>
//                             Price Agreed: KSh{' '}
//                             {Number(
//                               negotiationDetails.final_agreed_amount,
//                             ).toLocaleString()}
//                           </span>
//                         </>
//                       ) : negotiationDetails.pending_final_amount ? (
//                         <>
//                           <FaMoneyBillWave />
//                           <span>
//                             Pending: KSh{' '}
//                             {Number(
//                               negotiationDetails.pending_final_amount,
//                             ).toLocaleString()}
//                           </span>
//                           <button
//                             className="edit-agreement-btn-modern"
//                             onClick={() => {
//                               setEditFinalAgreementAmount(
//                                 negotiationDetails.pending_final_amount,
//                               );
//                               setShowEditFinalAgreementModal(true);
//                             }}
//                           >
//                             <FaEdit /> Edit
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <FaComments />
//                           <span>
//                             Negotiating - Discuss price with the client
//                           </span>
//                         </>
//                       )}
//                     </div>
//                   )
//                 )}

//                 {/* MESSAGES */}
//                 <div
//                   className="messages-area-modern"
//                   ref={messagesContainerRef}
//                   key={selectedConversation?.id}
//                 >
//                   {/*
//                     ✅ Render priority:
//                     1. isLoadingChat            → loader
//                     2. messages exist           → messages list
//                     3. hasLoadedOnce            → "no messages"
//                     4. otherwise                → loader
//                        (fallback: prevents premature "no messages")
//                   */}
//                   {isLoadingChat ? (
//                     <div className="loading-messages-modern">
//                       <div className="spinner-modern"></div>
//                       <p>Loading messages...</p>
//                     </div>
//                   ) : safeMessages.length > 0 ? (
//                     safeMessages.map((msg, index) => {
//                       const isSent = msg.sender_role === 'artisan';
//                       const isMilestone = msg.type === 'milestone';

//                       const previousMessage = safeMessages[index - 1];
//                       const currentDate = new Date(
//                         msg.timestamp || msg.created_at,
//                       );
//                       const previousDate = previousMessage
//                         ? new Date(
//                             previousMessage.timestamp ||
//                               previousMessage.created_at,
//                           )
//                         : null;

//                       const showDate =
//                         index === 0 ||
//                         (previousDate &&
//                           currentDate.toDateString() !==
//                             previousDate.toDateString());

//                       return (
//                         <React.Fragment
//                           key={msg.id || `${msg.timestamp}-${index}`}
//                         >
//                           {showDate && (
//                             <div className="date-divider-modern">
//                               <span>
//                                 {currentDate.toLocaleDateString(undefined, {
//                                   weekday: 'long',
//                                   year: 'numeric',
//                                   month: 'long',
//                                   day: 'numeric',
//                                 })}
//                               </span>
//                             </div>
//                           )}

//                           <div
//                             className={`message-bubble-modern ${
//                               isSent ? 'sent' : 'received'
//                             }`}
//                           >
//                             <div className="message-content-modern">
//                               {isMilestone ? (
//                                 <div className="milestone-update-modern">
//                                   <div className="milestone-header-modern">
//                                     <FaFlag className="milestone-icon-modern" />
//                                     <span className="milestone-label-modern">
//                                       Milestone Update
//                                     </span>
//                                   </div>
//                                   <div className="progress-section-modern">
//                                     <div className="progress-info-modern">
//                                       <span>
//                                         Progress: {msg.progress_percentage}%
//                                       </span>
//                                     </div>
//                                     <div className="progress-bar-container-modern">
//                                       <div
//                                         className="progress-fill-modern"
//                                         style={{
//                                           width: `${msg.progress_percentage}%`,
//                                         }}
//                                       />
//                                     </div>
//                                   </div>
//                                   <div className="milestone-note-modern">
//                                     {msg.note}
//                                   </div>
//                                 </div>
//                               ) : (
//                                 <p>{msg.message}</p>
//                               )}

//                               {msg.offer && (
//                                 <div className="offer-bubble-modern">
//                                   💰 Price Proposal: KSh{' '}
//                                   {Number(msg.offer).toLocaleString()}
//                                 </div>
//                               )}

//                               {Array.isArray(msg.images) &&
//                                 msg.images.length > 0 && (
//                                   <div className="message-images-modern">
//                                     {msg.images.map((img, imgIndex) => {
//                                       const imageUrl =
//                                         img.image_url || img.image;
//                                       return (
//                                         <img
//                                           key={img.id || imgIndex}
//                                           src={imageUrl}
//                                           alt="Attachment"
//                                           className="message-image-modern"
//                                           onClick={() => {
//                                             setSelectedImageForView(imageUrl);
//                                             setShowImageViewer(true);
//                                           }}
//                                         />
//                                       );
//                                     })}
//                                   </div>
//                                 )}
//                             </div>

//                             <div className="message-meta-modern">
//                               <span className="message-time-modern">
//                                 {formatMessageTime(
//                                   msg.created_at || msg.timestamp,
//                                 )}
//                               </span>
//                             </div>
//                           </div>
//                         </React.Fragment>
//                       );
//                     })
//                   ) : hasLoadedOnce ? (
//                     <div className="no-messages-modern">
//                       <div className="no-messages-icon-modern">💬</div>
//                       <p>No messages yet</p>
//                       <small>Send a message to start the conversation</small>
//                     </div>
//                   ) : (
//                     <div className="loading-messages-modern">
//                       <div className="spinner-modern"></div>
//                       <p>Loading messages...</p>
//                     </div>
//                   )}
//                   <div ref={messagesEndRef} />
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {imagePreviewUrls.length > 0 && !isNegotiationClosed && (
//                   <div className="image-preview-area-modern">
//                     <div className="preview-header-modern">
//                       <span>{imagePreviewUrls.length} image(s) selected</span>
//                       <button onClick={clearImages}>
//                         <FaTimes /> Clear
//                       </button>
//                     </div>

//                     <div className="preview-images-modern">
//                       {imagePreviewUrls.map((url, idx) => (
//                         <div key={idx} className="preview-image-wrapper-modern">
//                           <img src={url} alt={`Preview ${idx + 1}`} />
//                           <button
//                             className="remove-image-modern"
//                             onClick={() => removeSelectedImage(idx)}
//                           >
//                             <FaTimes />
//                           </button>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* CHAT INPUT */}
//                 {isNegotiationClosed ? (
//                   <div className="message-input-area-modern">
//                     <div className="closed-chat-banner">
//                       <div className="closed-icon">🔒</div>
//                       <div className="closed-text">
//                         <strong>This conversation is closed</strong>
//                         <span>
//                           Another artisan was selected for this project. You
//                           can no longer send or receive messages here.
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="message-input-area-modern">
//                     {isNegotiationPhase &&
//                       !negotiationDetails?.final_agreed_amount &&
//                       !hasPendingAgreement && (
//                         <button
//                           className="submit-agreement-btn-modern"
//                           onClick={() => setShowFinalAgreementModal(true)}
//                         >
//                           <FaHandshake /> Submit Final Agreement
//                         </button>
//                       )}

//                     {isNegotiationActive && (
//                       <div className="message-type-selector-modern">
//                         <button
//                           className={`type-btn-modern ${
//                             messageType === 'chat' ? 'active' : ''
//                           }`}
//                           onClick={() => setMessageType('chat')}
//                         >
//                           💬 Chat
//                         </button>
//                         <button
//                           className={`type-btn-modern ${
//                             messageType === 'milestone' ? 'active' : ''
//                           }`}
//                           onClick={() => setMessageType('milestone')}
//                         >
//                           🎯 Milestone
//                         </button>
//                       </div>
//                     )}

//                     {isNegotiationActive && messageType === 'milestone' ? (
//                       <div className="milestone-inputs-modern">
//                         <input
//                           type="number"
//                           placeholder="Progress %"
//                           value={progressPercentage}
//                           onChange={(e) =>
//                             setProgressPercentage(e.target.value)
//                           }
//                           className={`progress-input-modern ${
//                             isMilestoneComplete ? 'complete' : ''
//                           }`}
//                           min="0"
//                           max="100"
//                         />

//                         {isMilestoneComplete && (
//                           <div className="completion-notice-modern">
//                             <FaCheck className="completion-icon" />
//                             <span>
//                               🎉 This will mark the project as complete and
//                               notify the client about final payment!
//                             </span>
//                           </div>
//                         )}

//                         <textarea
//                           placeholder="Describe the milestone achieved..."
//                           value={milestoneNote}
//                           onChange={(e) => setMilestoneNote(e.target.value)}
//                           className="milestone-textarea-modern"
//                           rows={1}
//                         />

//                         <div className="milestone-actions-modern">
//                           <button
//                             className="attach-btn-modern"
//                             onClick={() => fileInputRef.current?.click()}
//                           >
//                             <FaImage />
//                           </button>

//                           <button
//                             onClick={sendMessage}
//                             disabled={
//                               !milestoneNote.trim() ||
//                               !progressPercentage ||
//                               isSending
//                             }
//                             className={`milestone-send-btn-modern ${
//                               isMilestoneComplete ? 'complete' : ''
//                             }`}
//                           >
//                             {isSending ? <FaClock /> : <FaPaperPlane />}
//                           </button>
//                         </div>
//                       </div>
//                     ) : (
//                       <div className="input-wrapper-modern">
//                         <div className="attach-options-modern">
//                           <button
//                             className="attach-btn-modern"
//                             onClick={() => fileInputRef.current?.click()}
//                             title="Upload from gallery"
//                           >
//                             <FaImage />
//                           </button>

//                           <button
//                             className="camera-btn-modern"
//                             onClick={handleCameraCapture}
//                             title="Take a photo"
//                           >
//                             <FaCamera />
//                           </button>
//                         </div>

//                         <input
//                           type="text"
//                           placeholder={
//                             isLoadingChat
//                               ? 'Loading conversation...'
//                               : 'Type a message...'
//                           }
//                           value={newMessage}
//                           onChange={(e) => setNewMessage(e.target.value)}
//                           onKeyPress={(e) => {
//                             if (e.key === 'Enter' && !e.shiftKey) {
//                               e.preventDefault();
//                               sendMessage();
//                             }
//                           }}
//                           className="message-input-modern"
//                           disabled={isChatDisabled || isLoadingChat}
//                         />

//                         <button
//                           onClick={sendMessage}
//                           disabled={
//                             isSending ||
//                             isChatDisabled ||
//                             isLoadingChat ||
//                             (!newMessage.trim() &&
//                               selectedImages.length === 0)
//                           }
//                           className="send-button-modern"
//                         >
//                           {isSending ? <FaClock /> : <FaPaperPlane />}
//                         </button>
//                       </div>
//                     )}

//                     <input
//                       type="file"
//                       ref={fileInputRef}
//                       style={{ display: 'none' }}
//                       accept="image/*"
//                       multiple
//                       onChange={handleImageSelect}
//                     />
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </div>

//         {/* SUBMIT FINAL AGREEMENT MODAL */}
//         <Modal
//           show={showFinalAgreementModal}
//           onHide={() => setShowFinalAgreementModal(false)}
//           centered
//           className="modal-modern"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title className="modal-title-final-agreement">
//               Submit Final Agreement
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="modal-content-modern">
//               <p>
//                 Submit the final agreed price for this project. The client
//                 will need to accept it.
//               </p>
//               <div className="input-group-modern">
//                 <label>Final Agreed Amount (KSh)</label>
//                 <input
//                   type="number"
//                   placeholder="Enter final agreed amount"
//                   value={finalAgreementAmount}
//                   onChange={(e) => setFinalAgreementAmount(e.target.value)}
//                 />
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowFinalAgreementModal(false)}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={handleSubmitFinalAgreement}
//               disabled={!finalAgreementAmount || isSubmittingFinalAgreement}
//             >
//               {isSubmittingFinalAgreement
//                 ? 'Submitting...'
//                 : 'Submit Agreement'}
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* EDIT FINAL AGREEMENT MODAL */}
//         <Modal
//           show={showEditFinalAgreementModal}
//           onHide={() => setShowEditFinalAgreementModal(false)}
//           centered
//           className="modal-modern edit-modal"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               <FaEdit /> Edit Final Agreement
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="modal-content-modern">
//               <p className="warning-text">
//                 Current pending amount: KSh{' '}
//                 {Number(
//                   negotiationDetails?.pending_final_amount || 0,
//                 ).toLocaleString()}
//               </p>

//               <div className="input-group-modern">
//                 <label>Corrected Amount (KSh)</label>
//                 <input
//                   type="number"
//                   placeholder="Enter corrected amount"
//                   value={editFinalAgreementAmount}
//                   onChange={(e) => setEditFinalAgreementAmount(e.target.value)}
//                 />
//               </div>

//               <div className="input-group-modern">
//                 <label>Reason for correction (Optional)</label>
//                 <textarea
//                   rows="3"
//                   placeholder="Explain why you're correcting the amount..."
//                   value={editAgreementNote}
//                   onChange={(e) => setEditAgreementNote(e.target.value)}
//                 />
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowEditFinalAgreementModal(false)}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={handleEditFinalAgreement}
//               disabled={isEditingFinalAgreement || !editFinalAgreementAmount}
//             >
//               {isEditingFinalAgreement ? 'Updating...' : 'Update Agreement'}
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* IMAGE VIEWER MODAL */}
//         <Modal
//           show={showImageViewer}
//           onHide={() => setShowImageViewer(false)}
//           centered
//           size="lg"
//           className="image-viewer-modal-modern"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>View Image</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="image-viewer-body-modern">
//             {selectedImageForView && (
//               <img
//                 src={selectedImageForView}
//                 alt="Full size"
//                 className="full-image-modern"
//               />
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowImageViewer(false)}
//             >
//               Close
//             </Button>
//             <Button
//               variant="primary"
//               onClick={() => window.open(selectedImageForView, '_blank')}
//             >
//               Download
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default withAuth(ArtisanMessages, 'artisan');


// src/pages/artisan/messages/ArtisanMessages.jsx
import React, { useState, useEffect, useRef } from 'react';
import './artisanmessages.scss';
import withAuth from '../../auth/WithAuth';
import Sidebar from '../../../components/layout/Sidebar';
import { serverUrlAuth } from '../../../serverUrl';
import { toast } from 'react-toastify';

import {
  FaSearch,
  FaUserCircle,
  FaComments,
  FaPaperPlane,
  FaArrowLeft,
  FaClock,
  FaImage,
  FaCheck,
  FaHandshake,
  FaMoneyBillWave,
  FaTimes,
  FaFlag,
  FaEdit,
  FaCamera,
} from 'react-icons/fa';

import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const ArtisanMessages = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const preselectedProposalId = queryParams.get('proposal');

  // ============================================================
  // STATE
  // ============================================================
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');

  const [loading, setLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);

  const [isLoadingChat, setIsLoadingChat] = useState(false);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [showSidebar, setShowSidebar] = useState(true);

  const [negotiationDetails, setNegotiationDetails] = useState(null);
  const [currentProjectId, setCurrentProjectId] = useState(null);

  const [messageType, setMessageType] = useState('chat');
  const [progressPercentage, setProgressPercentage] = useState('');
  const [milestoneNote, setMilestoneNote] = useState('');

  const [selectedImages, setSelectedImages] = useState([]);
  const [imagePreviewUrls, setImagePreviewUrls] = useState([]);

  const fileInputRef = useRef(null);

  const [showFinalAgreementModal, setShowFinalAgreementModal] = useState(false);
  const [finalAgreementAmount, setFinalAgreementAmount] = useState('');
  const [isSubmittingFinalAgreement, setIsSubmittingFinalAgreement] =
    useState(false);

  const [showEditFinalAgreementModal, setShowEditFinalAgreementModal] =
    useState(false);
  const [editFinalAgreementAmount, setEditFinalAgreementAmount] = useState('');
  const [isEditingFinalAgreement, setIsEditingFinalAgreement] = useState(false);
  const [editAgreementNote, setEditAgreementNote] = useState('');

  const [showImageViewer, setShowImageViewer] = useState(false);
  const [selectedImageForView, setSelectedImageForView] = useState(null);

  const messagesEndRef = useRef(null);
  const messageIntervalRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const isPollingRef = useRef(false);

  const activeProposalRef = useRef(null);
  const activeProjectRef = useRef(null);

  const conversationTokenRef = useRef(0);
  const abortControllerRef = useRef(null);

  // ✅ Per-proposal phase cache (see client file for full explanation)
  const proposalPhaseRef = useRef(new Map());

  // ============================================================
  // DERIVED STATE
  // ============================================================
  const isNegotiationActive = negotiationDetails?.is_selected === true;

  const isNegotiationClosed =
    !isNegotiationActive && negotiationDetails?.is_closed === true;

  const isChatDisabled = isNegotiationClosed;

  const isNegotiationPhase = !isNegotiationActive && !isNegotiationClosed;

  const isMilestoneComplete =
    messageType === 'milestone' &&
    parseInt(progressPercentage, 10) === 100;

  const hasPendingAgreement =
    negotiationDetails?.pending_final_amount &&
    !negotiationDetails?.final_agreed_amount;

  const safeMessages = Array.isArray(messages) ? messages : [];

  // Helper: consult the cache first, then fall back to state.
  const resolvePhase = (proposalId) => {
    if (!proposalId) return false;

    const cached = proposalPhaseRef.current.get(String(proposalId));
    if (typeof cached === 'boolean') return cached;

    return isNegotiationActive;
  };

  // ============================================================
  // MESSAGE NORMALIZER
  // ============================================================
  const normalizeMessages = (data, fallbackSource = 'negotiation') => {
    let rawMessages = [];

    if (Array.isArray(data)) {
      rawMessages = data;
    } else if (Array.isArray(data?.conversation)) {
      rawMessages = data.conversation;
    } else if (Array.isArray(data?.messages)) {
      rawMessages = data.messages;
    }

    return rawMessages.map((msg) => ({
      ...msg,
      id: msg.id,
      message: msg.message || msg.content || '',
      timestamp: msg.timestamp || msg.created_at,
      sender_role: msg.sender_role,
      sender_name: msg.sender_name,
      sender_id: msg.sender_id || msg.sender,
      read_by_client: msg.read_by_client,
      read_by_artisan: msg.read_by_artisan,
      type: msg.type || 'chat',
      source: msg.source || fallbackSource,
      negotiation_id:
        msg.negotiation_id || msg.negotiation || data?.negotiation || null,
    }));
  };

  // ============================================================
  // BODY CLASS
  // ============================================================
  useEffect(() => {
    document.body.classList.add('artisan-messages-active');
    return () => {
      document.body.classList.remove('artisan-messages-active');
    };
  }, []);

  // ============================================================
  // CAMERA
  // ============================================================
  const handleCameraCapture = () => {
    const cameraInput = document.createElement('input');
    cameraInput.type = 'file';
    cameraInput.accept = 'image/*';
    cameraInput.capture = 'environment';
    cameraInput.multiple = false;

    cameraInput.onchange = (e) => {
      const files = Array.from(e.target.files || []);
      if (files.length > 0) {
        setSelectedImages((prev) => [...prev, ...files]);
        setImagePreviewUrls((prev) => [
          ...prev,
          ...files.map((file) => URL.createObjectURL(file)),
        ]);
        toast.success('📸 Photo captured successfully!');
      }
      if (document.body.contains(cameraInput)) {
        document.body.removeChild(cameraInput);
      }
    };

    cameraInput.oncancel = () => {
      if (document.body.contains(cameraInput)) {
        document.body.removeChild(cameraInput);
      }
    };

    document.body.appendChild(cameraInput);
    cameraInput.click();
  };

  // ============================================================
  // MARK CONVERSATION AS READ
  // ============================================================
  const markConversationAsRead = async (
    projectId,
    negotiationId,
    refreshInbox = true,
  ) => {
    if (!projectId || !negotiationId) return;

    try {
      await serverUrlAuth.post(
        `/updates/mark-messages-as-read/${projectId}/${negotiationId}/mark-all-read/`,
      );

      if (refreshInbox) {
        const convResponse = await serverUrlAuth.get('negotiations/inbox/');
        const data = Array.isArray(convResponse.data) ? convResponse.data : [];

        data.forEach((conv) => {
          if (
            conv.proposal != null &&
            typeof conv.is_selected === 'boolean'
          ) {
            proposalPhaseRef.current.set(
              String(conv.proposal),
              conv.is_selected,
            );
          }
        });

        setConversations(data);
      }
    } catch (err) {
      console.error(
        'Error marking conversation as read:',
        err.response?.data || err,
      );
    }
  };

  // ============================================================
  // PROPOSAL DETAILS
  // ============================================================
  const fetchProposalDetails = async (proposalId) => {
    if (!proposalId) return null;
    try {
      const response = await serverUrlAuth.get(
        `proposals/proposal-detail/${proposalId}/`,
      );
      return response.data;
    } catch (err) {
      console.error('Error fetching proposal details:', err);
      return null;
    }
  };

  // ============================================================
  // NEGOTIATION DETAILS
  // ============================================================
  const fetchNegotiationDetails = async (proposalId) => {
    if (!proposalId) return null;

    try {
      const response = await serverUrlAuth.get(
        `negotiations/proposal/${proposalId}/`,
      );

      if (
        activeProposalRef.current &&
        String(activeProposalRef.current) !== String(proposalId)
      ) {
        return null;
      }

      const details = response.data;

      // ✅ Update the phase cache
      proposalPhaseRef.current.set(
        String(proposalId),
        details?.is_selected === true,
      );

      setNegotiationDetails(details);

      return details;
    } catch (err) {
      console.error('Error fetching negotiation details:', err);
      return null;
    }
  };

  // ============================================================
  // FETCH MESSAGES
  // ============================================================
  const fetchMessages = async (
    projectId,
    proposalId,
    isInitialLoad = false,
    token = null,
    phaseOverride = null,
  ) => {
    if (!projectId || !proposalId) {
      if (isInitialLoad) {
        setIsLoadingChat(false);
        setHasLoadedOnce(true);
      }
      return;
    }

    const myToken =
      token !== null ? token : conversationTokenRef.current;

    // ✅ Resolve the phase — explicit arg > cache > state
    const phaseIsActive =
      phaseOverride !== null
        ? phaseOverride
        : proposalPhaseRef.current.has(String(proposalId))
        ? proposalPhaseRef.current.get(String(proposalId)) === true
        : isNegotiationActive;

    if (
      activeProjectRef.current &&
      String(activeProjectRef.current) !== String(projectId)
    ) {
      if (isInitialLoad) {
        setIsLoadingChat(false);
        setHasLoadedOnce(true);
      }
      return;
    }

    try {
      let rawMessages = [];

      if (phaseIsActive) {
        const response = await serverUrlAuth.get(
          `/updates/messages/${projectId}/`,
          { signal: abortControllerRef.current?.signal },
        );

        if (conversationTokenRef.current !== myToken) return;

        rawMessages = Array.isArray(response.data?.conversation)
          ? response.data.conversation
          : Array.isArray(response.data)
          ? response.data
          : [];
      } else {
        const response = await serverUrlAuth.get(
          `negotiations/proposal/${proposalId}/messages/`,
          { signal: abortControllerRef.current?.signal },
        );

        if (conversationTokenRef.current !== myToken) return;

        rawMessages = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.messages)
          ? response.data.messages
          : [];
      }

      if (conversationTokenRef.current !== myToken) return;

      const processed = normalizeMessages(
        rawMessages,
        phaseIsActive ? 'project' : 'negotiation',
      ).sort((a, b) => {
        const dateA = new Date(a.timestamp || 0).getTime();
        const dateB = new Date(b.timestamp || 0).getTime();
        return dateA - dateB;
      });

      if (isInitialLoad) {
        setMessages(processed);
        setIsLoadingChat(false);
        setHasLoadedOnce(true);
        setTimeout(scrollToBottom, 0);
      } else {
        setMessages(processed);
        maybeScrollToBottom();
      }
    } catch (err) {
      if (
        err.name === 'CanceledError' ||
        err.code === 'ERR_CANCELED'
      ) {
        return;
      }

      if (conversationTokenRef.current !== myToken) return;

      console.error(
        'Error fetching messages:',
        err.response?.data || err,
      );

      if (isInitialLoad) {
        setTimeout(() => {
          if (conversationTokenRef.current === myToken) {
            setMessages([]);
            setIsLoadingChat(false);
            setHasLoadedOnce(true);
          }
        }, 800);
        toast.error('Failed to load messages');
      }
    }
  };

  // ============================================================
  // FETCH CONVERSATIONS
  // ============================================================
  const fetchConversations = async () => {
    try {
      const response = await serverUrlAuth.get('negotiations/inbox/');
      const inboxData = Array.isArray(response.data) ? response.data : [];

      // ✅ Prime phase cache from every conversation
      inboxData.forEach((conv) => {
        if (
          conv.proposal != null &&
          typeof conv.is_selected === 'boolean'
        ) {
          proposalPhaseRef.current.set(
            String(conv.proposal),
            conv.is_selected,
          );
        }
      });

      setConversations(inboxData);

      if (preselectedProposalId && !selectedConversation) {
        const conversation = inboxData.find(
          (c) => c.proposal?.toString() === preselectedProposalId.toString(),
        );

        if (conversation) {
          await handleSelectConversation(conversation, true);
        } else {
          await fetchSingleConversation(preselectedProposalId);
        }
      }
    } catch (err) {
      console.error('Error fetching conversations:', err);
      toast.error('Failed to load conversations');
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // FETCH SINGLE CONVERSATION
  // ============================================================
  const fetchSingleConversation = async (proposalId) => {
    if (!proposalId) return;

    stopPolling();
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }

    conversationTokenRef.current += 1;
    const myToken = conversationTokenRef.current;

    setIsLoadingChat(true);
    setHasLoadedOnce(false);
    setMessages([]);
    setNegotiationDetails(null);

    try {
      const response = await serverUrlAuth.get(
        `negotiations/proposal/${proposalId}/`,
      );

      if (conversationTokenRef.current !== myToken) return;

      const convData = response.data;
      const projectId = convData.proposal_details?.project;
      const negotiationId = convData.id;

      // ✅ Update cache
      proposalPhaseRef.current.set(
        String(proposalId),
        convData.is_selected === true,
      );

      const newConversation = {
        id: negotiationId,
        proposal: proposalId,
        project_id: projectId,
        project_title: convData.project_title,
        artisan_name: convData.artisan_name,
        client_name: convData.client_name,
        last_message_time: convData.created_at,
        unread_count: 0,
        is_closed: convData.is_closed,
        is_selected: convData.is_selected,
      };

      activeProposalRef.current = proposalId;
      activeProjectRef.current = projectId;

      setCurrentProjectId(projectId);
      setSelectedConversation(newConversation);
      setShowSidebar(false);
      setNegotiationDetails(convData);

      abortControllerRef.current = new AbortController();

      await fetchProposalDetails(proposalId);

      // ✅ Explicit phase — correct endpoint on first try
      await fetchMessages(
        projectId,
        proposalId,
        true,
        myToken,
        convData.is_selected === true,
      );

      if (conversationTokenRef.current !== myToken) return;

      if (negotiationId) {
        await markConversationAsRead(projectId, negotiationId, true);
      }
    } catch (err) {
      if (conversationTokenRef.current !== myToken) return;
      console.error('Error fetching single conversation:', err);
      toast.error('Could not open conversation');

      setTimeout(() => {
        if (conversationTokenRef.current === myToken) {
          setIsLoadingChat(false);
          setHasLoadedOnce(true);
        }
      }, 1500);
    }
  };

  // ============================================================
  // SELECT CONVERSATION
  // ============================================================
  const handleSelectConversation = async (
    conversation,
    fromPreselection = false,
  ) => {
    const projectId =
      conversation.proposal_details?.project || conversation.project_id;
    const proposalId = conversation.proposal;
    const conversationNegotiationId =
      conversation.id || conversation.negotiation;

    if (!proposalId) {
      toast.error('This conversation has no proposal ID');
      return;
    }

    if (!projectId) {
      toast.error('This conversation has no project ID');
      return;
    }

    stopPolling();
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }

    conversationTokenRef.current += 1;
    const myToken = conversationTokenRef.current;

    setIsLoadingChat(true);
    setHasLoadedOnce(false);
    setMessages([]);
    setCurrentProjectId(projectId);
    setSelectedConversation(conversation);
    setShowSidebar(false);
    setNewMessage('');
    setProgressPercentage('');
    setMilestoneNote('');
    clearImages();
    setNegotiationDetails(null);

    activeProposalRef.current = proposalId;
    activeProjectRef.current = projectId;

    if (!fromPreselection) {
      const params = new URLSearchParams(location.search);
      params.set('proposal', proposalId);
      navigate(`${location.pathname}?${params.toString()}`, {
        replace: true,
      });
    }

    try {
      abortControllerRef.current = new AbortController();

      await fetchProposalDetails(proposalId);

      const negotiation = await fetchNegotiationDetails(proposalId);

      if (conversationTokenRef.current !== myToken) return;

      const negotiationId = negotiation?.id || conversationNegotiationId;

      if (!negotiationId) {
        toast.error('Negotiation ID not available');
        setTimeout(() => {
          if (conversationTokenRef.current === myToken) {
            setIsLoadingChat(false);
            setHasLoadedOnce(true);
          }
        }, 800);
        return;
      }

      const isActive = negotiation?.is_selected === true;

      // ✅ Explicit phase — correct endpoint on first try
      await fetchMessages(
        projectId,
        proposalId,
        true,
        myToken,
        isActive,
      );

      if (conversationTokenRef.current !== myToken) return;

      await markConversationAsRead(projectId, negotiationId, true);
    } catch (err) {
      if (conversationTokenRef.current !== myToken) return;
      console.error('Error selecting conversation:', err);
      toast.error('Could not load conversation');

      setTimeout(() => {
        if (conversationTokenRef.current === myToken) {
          setIsLoadingChat(false);
          setHasLoadedOnce(true);
        }
      }, 1500);
    }
  };

  // ============================================================
  // IMAGE SELECTION
  // ============================================================
  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files || []);
    const validFiles = files.filter((file) =>
      file.type.startsWith('image/'),
    );

    setSelectedImages((prev) => [...prev, ...validFiles]);
    setImagePreviewUrls((prev) => [
      ...prev,
      ...validFiles.map((file) => URL.createObjectURL(file)),
    ]);

    e.target.value = '';
  };

  const removeSelectedImage = (index) => {
    if (imagePreviewUrls[index]) {
      URL.revokeObjectURL(imagePreviewUrls[index]);
    }
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));
    setImagePreviewUrls((prev) => prev.filter((_, i) => i !== index));
  };

  const clearImages = () => {
    imagePreviewUrls.forEach((url) => URL.revokeObjectURL(url));
    setSelectedImages([]);
    setImagePreviewUrls([]);
  };

  // ============================================================
  // SEND MESSAGE
  // ============================================================
  const sendMessage = async () => {
    if (isChatDisabled) {
      toast.info('This conversation is closed.');
      return;
    }

    if (!selectedConversation?.proposal) {
      toast.error('No conversation selected');
      return;
    }

    if (isNegotiationActive && messageType === 'milestone') {
      if (!milestoneNote.trim()) {
        toast.error('Please add a note for the milestone');
        return;
      }
      if (
        !progressPercentage ||
        Number(progressPercentage) < 0 ||
        Number(progressPercentage) > 100
      ) {
        toast.error('Please enter a valid progress percentage (0-100)');
        return;
      }
    } else if (!newMessage.trim() && selectedImages.length === 0) {
      toast.error('Please enter a message or attach an image');
      return;
    }

    setIsSending(true);

    const myToken = conversationTokenRef.current;

    // ✅ Resolve phase from cache — never stale
    const phaseIsActive = resolvePhase(selectedConversation.proposal);

    try {
      let response;

      if (phaseIsActive && currentProjectId) {
        const formData = new FormData();
        const isMilestoneMsg = messageType === 'milestone';
        const isMilestoneCompleteLocal =
          isMilestoneMsg && parseInt(progressPercentage, 10) === 100;

        formData.append('type', isMilestoneMsg ? 'milestone' : 'chat');

        if (isMilestoneMsg) {
          formData.append('progress_percentage', progressPercentage);
          formData.append('note', milestoneNote);
        } else {
          formData.append('message', newMessage.trim() || '📷 Image attached');
        }

        selectedImages.forEach((image) => {
          formData.append('uploaded_images', image);
        });

        response = await serverUrlAuth.post(
          `/updates/post-updates/${currentProjectId}/`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } },
        );

        if (isMilestoneCompleteLocal) {
          const paymentMessage = `🎉 Your product is ready. To proceed with delivery, kindly complete the final payment. Delivery will begin as soon as your payment is confirmed.`;

          await serverUrlAuth.post(
            `/updates/post-updates/${currentProjectId}/`,
            { type: 'chat', message: paymentMessage },
            { headers: { 'Content-Type': 'application/json' } },
          );

          toast.success(
            '🎉 Project marked as complete! Payment notification sent to client.',
          );
        }

        setProgressPercentage('');
        setMilestoneNote('');
      } else {
        const proposalId = selectedConversation.proposal;
        const formData = new FormData();

        formData.append('message', newMessage.trim() || '📷 Image attached');

        selectedImages.forEach((image) => {
          formData.append('images', image);
        });

        response = await serverUrlAuth.post(
          `negotiations/proposal/${proposalId}/messages/`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } },
        );
      }

      setNewMessage('');
      clearImages();

      if (conversationTokenRef.current === myToken) {
        await fetchMessages(
          currentProjectId,
          selectedConversation.proposal,
          false,
          myToken,
          phaseIsActive,
        );
      }

      const convResponse = await serverUrlAuth.get('negotiations/inbox/');

      if (conversationTokenRef.current === myToken) {
        const data = Array.isArray(convResponse.data) ? convResponse.data : [];

        data.forEach((conv) => {
          if (
            conv.proposal != null &&
            typeof conv.is_selected === 'boolean'
          ) {
            proposalPhaseRef.current.set(
              String(conv.proposal),
              conv.is_selected,
            );
          }
        });

        setConversations(data);
      }
    } catch (err) {
      console.error('Failed to send message:', err.response?.data || err);
      toast.error('Failed to send message.');
    } finally {
      setIsSending(false);
    }
  };

  // ============================================================
  // SUBMIT FINAL AGREEMENT
  // ============================================================
  const handleSubmitFinalAgreement = async () => {
    if (
      !finalAgreementAmount ||
      !selectedConversation ||
      !negotiationDetails
    )
      return;

    if (Number(finalAgreementAmount) <= 0) {
      toast.error('Please enter a valid amount');
      return;
    }

    const proposalId = selectedConversation.proposal;
    if (!proposalId) {
      toast.error('No proposal selected');
      return;
    }
    if (!negotiationDetails.id) {
      toast.error('Negotiation details not available');
      return;
    }

    setIsSubmittingFinalAgreement(true);

    try {
      await serverUrlAuth.patch(
        `negotiations/submit-final-agreement/${negotiationDetails.id}/`,
        { final_agreed_amount: finalAgreementAmount },
      );

      toast.success(
        'Final agreement submitted! Waiting for client acceptance.',
      );

      setShowFinalAgreementModal(false);
      setFinalAgreementAmount('');

      await fetchNegotiationDetails(proposalId);

      await fetchMessages(
        currentProjectId,
        proposalId,
        false,
        conversationTokenRef.current,
        resolvePhase(proposalId),
      );
    } catch (err) {
      console.error('Error submitting final agreement:', err);
      toast.error('Failed to submit final agreement');
    } finally {
      setIsSubmittingFinalAgreement(false);
    }
  };

  // ============================================================
  // EDIT FINAL AGREEMENT
  // ============================================================
  const handleEditFinalAgreement = async () => {
    if (
      !editFinalAgreementAmount ||
      Number(editFinalAgreementAmount) <= 0
    ) {
      toast.error('Please enter a valid amount');
      return;
    }

    if (!selectedConversation?.proposal) {
      toast.error('No proposal selected');
      return;
    }

    if (!negotiationDetails?.id) {
      toast.error('Negotiation details not available');
      return;
    }

    setIsEditingFinalAgreement(true);

    try {
      const proposalId = selectedConversation.proposal;

      await serverUrlAuth.patch(
        `negotiations/submit-final-agreement/${negotiationDetails.id}/`,
        { final_agreed_amount: editFinalAgreementAmount },
      );

      toast.success('Final agreement amount updated successfully!');

      setShowEditFinalAgreementModal(false);
      setEditFinalAgreementAmount('');

      const note = editAgreementNote.trim();
      setEditAgreementNote('');

      await fetchNegotiationDetails(proposalId);

      if (note) {
        await serverUrlAuth.post(
          `negotiations/proposal/${proposalId}/messages/`,
          { message: `📝 Note about updated agreement: ${note}` },
        );
      }

      await fetchMessages(
        currentProjectId,
        proposalId,
        false,
        conversationTokenRef.current,
        resolvePhase(proposalId),
      );

      const convResponse = await serverUrlAuth.get('negotiations/inbox/');
      const data = Array.isArray(convResponse.data) ? convResponse.data : [];

      data.forEach((conv) => {
        if (
          conv.proposal != null &&
          typeof conv.is_selected === 'boolean'
        ) {
          proposalPhaseRef.current.set(
            String(conv.proposal),
            conv.is_selected,
          );
        }
      });

      setConversations(data);
    } catch (err) {
      console.error('Error updating final agreement:', err);
      toast.error('Failed to update final agreement');
    } finally {
      setIsEditingFinalAgreement(false);
    }
  };

  // ============================================================
  // SCROLL HELPERS
  // ============================================================
  const scrollToBottom = () => {
    setTimeout(() => {
      if (messagesContainerRef.current) {
        messagesContainerRef.current.scrollTop =
          messagesContainerRef.current.scrollHeight;
      }
    }, 100);
  };

  const maybeScrollToBottom = () => {
    setTimeout(() => {
      const el = messagesContainerRef.current;
      if (!el) return;

      const distanceFromBottom =
        el.scrollHeight - el.scrollTop - el.clientHeight;

      if (distanceFromBottom < 120) {
        el.scrollTop = el.scrollHeight;
      }
    }, 50);
  };

  // ============================================================
  // POLLING
  // ============================================================
  const startPolling = () => {
    if (messageIntervalRef.current) clearInterval(messageIntervalRef.current);

    messageIntervalRef.current = setInterval(async () => {
      if (isNegotiationClosed) return;
      if (
        !selectedConversation ||
        !currentProjectId ||
        isPollingRef.current
      )
        return;

      const myToken = conversationTokenRef.current;

      isPollingRef.current = true;

      try {
        const proposalId = selectedConversation.proposal;
        if (!proposalId) return;

        const negotiation = await fetchNegotiationDetails(proposalId);

        if (conversationTokenRef.current !== myToken) return;

        const negotiationId = negotiation?.id || selectedConversation.id;

        // ✅ Explicit phase from fresh negotiation response
        const isActive = negotiation?.is_selected === true;

        await fetchMessages(
          currentProjectId,
          proposalId,
          false,
          myToken,
          isActive,
        );

        if (conversationTokenRef.current !== myToken) return;

        await markConversationAsRead(
          currentProjectId,
          negotiationId,
          false,
        );

        const convResponse = await serverUrlAuth.get('negotiations/inbox/');

        if (conversationTokenRef.current !== myToken) return;

        const data = Array.isArray(convResponse.data) ? convResponse.data : [];

        data.forEach((conv) => {
          if (
            conv.proposal != null &&
            typeof conv.is_selected === 'boolean'
          ) {
            proposalPhaseRef.current.set(
              String(conv.proposal),
              conv.is_selected,
            );
          }
        });

        setConversations(data);
      } catch (error) {
        if (
          error.name === 'CanceledError' ||
          error.code === 'ERR_CANCELED'
        ) {
          return;
        }
        console.error('Polling error:', error.response?.data || error);
      } finally {
        isPollingRef.current = false;
      }
    }, 5000);
  };

  const stopPolling = () => {
    if (messageIntervalRef.current) {
      clearInterval(messageIntervalRef.current);
      messageIntervalRef.current = null;
    }
    isPollingRef.current = false;
  };

  // ============================================================
  // FILTER / FORMAT
  // ============================================================
  const filteredConversations = Array.isArray(conversations)
    ? conversations.filter(
        (conv) =>
          conv.client_name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          conv.project_title
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()),
      )
    : [];

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now - date;
    const hours = Math.floor(diff / (1000 * 60 * 60));

    if (hours < 1) {
      const mins = Math.floor(diff / (1000 * 60));
      return mins === 0 ? 'Just now' : `${mins} min ago`;
    }
    if (hours < 24) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    }
    if (hours < 48) return 'Yesterday';
    return date.toLocaleDateString();
  };

  const formatMessageTime = (timestamp) => {
    if (!timestamp) return '';
    return new Date(timestamp).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getUnreadCount = (conversation) => conversation?.unread_count || 0;

  const getDisplayName = (conversation) =>
    conversation?.client_name || 'Client';

  const handleBackToDashboard = () => {
    navigate('/artisan-dashboard');
  };

  // ============================================================
  // EFFECTS
  // ============================================================
  useEffect(() => {
    fetchConversations();
    return () => stopPolling();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      selectedConversation &&
      currentProjectId &&
      !isNegotiationClosed &&
      !isLoadingChat
    ) {
      startPolling();
    } else {
      stopPolling();
    }
    return () => stopPolling();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedConversation,
    currentProjectId,
    isNegotiationActive,
    isNegotiationClosed,
    isLoadingChat,
  ]);

  useEffect(() => {
    return () => {
      imagePreviewUrls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [imagePreviewUrls]);

  // ============================================================
  // LOADING
  // ============================================================
  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="modern-dashboard artisan-messages-page hide-nav-mobile">
          <div className="dashboard-loader">
            <div className="wooden-spinner"></div>
            <p>Loading conversations...</p>
          </div>
        </div>
      </>
    );
  }

  // ============================================================
  // RENDER
  // ============================================================
  return (
    <>
      <Sidebar />

      <div className="modern-dashboard artisan-messages-page hide-nav-mobile">
        <div className="messages-container-modern">
          {/* CONVERSATIONS SIDEBAR */}
          <div
            className={`conversations-sidebar-modern ${
              showSidebar ? 'open' : 'closed'
            }`}
          >
            <div className="sidebar-header-modern">
              <div className="search-bar-modern">
                <button
                  type="button"
                  className="mobile-back-btn-modern"
                  onClick={handleBackToDashboard}
                  aria-label="Back to dashboard"
                >
                  <FaArrowLeft />
                </button>

                <FaSearch className="search-icon-modern" />

                <input
                  type="text"
                  placeholder="Search clients..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="conversations-list-modern">
              {filteredConversations.length === 0 ? (
                <div className="empty-state-modern">
                  <div className="empty-icon-modern">💬</div>
                  <h4>No conversations yet</h4>
                  <p>When clients message you, they'll appear here.</p>
                </div>
              ) : (
                filteredConversations.map((conv) => {
                  const unreadCount = getUnreadCount(conv);
                  return (
                    <div
                      key={conv.id}
                      className={`conversation-item-modern ${
                        selectedConversation?.id === conv.id ? 'active' : ''
                      } ${conv.is_closed ? 'closed' : ''}`}
                      onClick={() => handleSelectConversation(conv)}
                    >
                      <div className="avatar-modern">
                        <FaUserCircle />
                      </div>

                      <div className="conversation-info-modern">
                        <div className="conversation-header-modern">
                          <h4>{getDisplayName(conv)}</h4>
                          <span className="timestamp-modern">
                            {formatTime(conv.last_message_time)}
                          </span>
                        </div>

                        <div className="conversation-preview-modern">
                          <p className="project-title-modern">
                            {conv.project_title}
                          </p>
                          {conv.is_closed && (
                            <span className="closed-badge-mini">
                              🔒 Closed
                            </span>
                          )}
                        </div>
                      </div>

                      {unreadCount > 0 && (
                        <div className="unread-badge-modern">
                          {unreadCount}
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </div>

          {/* CHAT AREA */}
          <div className="chat-area-modern">
            {!selectedConversation ? (
              <div className="no-conversation-selected-modern">
                <div className="no-chat-icon-modern">
                  <FaComments />
                </div>
                <h3>Select a conversation</h3>
                <p>Choose a chat from the list to start messaging</p>
                <button
                  className="back-to-chats-btn-modern"
                  onClick={() => setShowSidebar(true)}
                >
                  Back to Chats
                </button>
              </div>
            ) : (
              <>
                {/* CHAT HEADER */}
                <div className="chat-header-modern">
                  <button
                    className="back-button-modern"
                    onClick={() => {
                      stopPolling();
                      if (abortControllerRef.current) {
                        abortControllerRef.current.abort();
                        abortControllerRef.current = null;
                      }
                      conversationTokenRef.current += 1;

                      setIsLoadingChat(false);
                      setHasLoadedOnce(false);
                      setShowSidebar(true);
                      setSelectedConversation(null);
                      setMessages([]);
                      setCurrentProjectId(null);
                      setNegotiationDetails(null);
                      activeProposalRef.current = null;
                      activeProjectRef.current = null;
                      navigate(location.pathname, { replace: true });
                    }}
                  >
                    <FaArrowLeft />
                  </button>

                  <div className="chat-user-info-modern">
                    <div className="user-avatar-modern">
                      <FaUserCircle />
                    </div>
                    <div className="user-details-modern">
                      <h3>{getDisplayName(selectedConversation)}</h3>
                      <p className="project-context-modern">
                        Project: {selectedConversation.project_title}
                      </p>
                    </div>
                  </div>
                </div>

                {/* STATUS BANNER */}
                {isNegotiationActive ? (
                  <div className="status-banner-modern success">
                    <FaCheck className="status-icon" />
                    <span>Project In Progress</span>
                    <small>
                      Send updates and milestones to keep the client informed
                    </small>
                  </div>
                ) : isNegotiationClosed ? (
                  <div className="status-banner-modern closed">
                    <FaTimes className="status-icon" />
                    <span>Negotiation Closed</span>
                    <small>
                      Another artisan was selected for this project.
                    </small>
                  </div>
                ) : (
                  negotiationDetails && (
                    <div className="status-banner-modern info">
                      {negotiationDetails.final_agreed_amount ? (
                        <>
                          <FaHandshake />
                          <span>
                            Price Agreed: KSh{' '}
                            {Number(
                              negotiationDetails.final_agreed_amount,
                            ).toLocaleString()}
                          </span>
                        </>
                      ) : negotiationDetails.pending_final_amount ? (
                        <>
                          <FaMoneyBillWave />
                          <span>
                            Pending: KSh{' '}
                            {Number(
                              negotiationDetails.pending_final_amount,
                            ).toLocaleString()}
                          </span>
                          <button
                            className="edit-agreement-btn-modern"
                            onClick={() => {
                              setEditFinalAgreementAmount(
                                negotiationDetails.pending_final_amount,
                              );
                              setShowEditFinalAgreementModal(true);
                            }}
                          >
                            <FaEdit /> Edit
                          </button>
                        </>
                      ) : (
                        <>
                          <FaComments />
                          <span>
                            Negotiating - Discuss price with the client
                          </span>
                        </>
                      )}
                    </div>
                  )
                )}

                {/* MESSAGES */}
                <div
                  className="messages-area-modern"
                  ref={messagesContainerRef}
                  key={selectedConversation?.id}
                >
                  {isLoadingChat ? (
                    <div className="loading-messages-modern">
                      <div className="spinner-modern"></div>
                      <p>Loading messages...</p>
                    </div>
                  ) : safeMessages.length > 0 ? (
                    safeMessages.map((msg, index) => {
                      const isSent = msg.sender_role === 'artisan';
                      const isMilestone = msg.type === 'milestone';

                      const previousMessage = safeMessages[index - 1];
                      const currentDate = new Date(
                        msg.timestamp || msg.created_at,
                      );
                      const previousDate = previousMessage
                        ? new Date(
                            previousMessage.timestamp ||
                              previousMessage.created_at,
                          )
                        : null;

                      const showDate =
                        index === 0 ||
                        (previousDate &&
                          currentDate.toDateString() !==
                            previousDate.toDateString());

                      return (
                        <React.Fragment
                          key={msg.id || `${msg.timestamp}-${index}`}
                        >
                          {showDate && (
                            <div className="date-divider-modern">
                              <span>
                                {currentDate.toLocaleDateString(undefined, {
                                  weekday: 'long',
                                  year: 'numeric',
                                  month: 'long',
                                  day: 'numeric',
                                })}
                              </span>
                            </div>
                          )}

                          <div
                            className={`message-bubble-modern ${
                              isSent ? 'sent' : 'received'
                            }`}
                          >
                            <div className="message-content-modern">
                              {isMilestone ? (
                                <div className="milestone-update-modern">
                                  <div className="milestone-header-modern">
                                    <FaFlag className="milestone-icon-modern" />
                                    <span className="milestone-label-modern">
                                      Milestone Update
                                    </span>
                                  </div>
                                  <div className="progress-section-modern">
                                    <div className="progress-info-modern">
                                      <span>
                                        Progress: {msg.progress_percentage}%
                                      </span>
                                    </div>
                                    <div className="progress-bar-container-modern">
                                      <div
                                        className="progress-fill-modern"
                                        style={{
                                          width: `${msg.progress_percentage}%`,
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="milestone-note-modern">
                                    {msg.note}
                                  </div>
                                </div>
                              ) : (
                                <p>{msg.message}</p>
                              )}

                              {msg.offer && (
                                <div className="offer-bubble-modern">
                                  💰 Price Proposal: KSh{' '}
                                  {Number(msg.offer).toLocaleString()}
                                </div>
                              )}

                              {Array.isArray(msg.images) &&
                                msg.images.length > 0 && (
                                  <div className="message-images-modern">
                                    {msg.images.map((img, imgIndex) => {
                                      const imageUrl =
                                        img.image_url || img.image;
                                      return (
                                        <img
                                          key={img.id || imgIndex}
                                          src={imageUrl}
                                          alt="Attachment"
                                          className="message-image-modern"
                                          onClick={() => {
                                            setSelectedImageForView(imageUrl);
                                            setShowImageViewer(true);
                                          }}
                                        />
                                      );
                                    })}
                                  </div>
                                )}
                            </div>

                            <div className="message-meta-modern">
                              <span className="message-time-modern">
                                {formatMessageTime(
                                  msg.created_at || msg.timestamp,
                                )}
                              </span>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })
                  ) : hasLoadedOnce ? (
                    <div className="no-messages-modern">
                      <div className="no-messages-icon-modern">💬</div>
                      <p>No messages yet</p>
                      <small>Send a message to start the conversation</small>
                    </div>
                  ) : (
                    <div className="loading-messages-modern">
                      <div className="spinner-modern"></div>
                      <p>Loading messages...</p>
                    </div>
                  )}
                  <div ref={messagesEndRef} />
                </div>

                {/* IMAGE PREVIEW */}
                {imagePreviewUrls.length > 0 && !isNegotiationClosed && (
                  <div className="image-preview-area-modern">
                    <div className="preview-header-modern">
                      <span>{imagePreviewUrls.length} image(s) selected</span>
                      <button onClick={clearImages}>
                        <FaTimes /> Clear
                      </button>
                    </div>

                    <div className="preview-images-modern">
                      {imagePreviewUrls.map((url, idx) => (
                        <div key={idx} className="preview-image-wrapper-modern">
                          <img src={url} alt={`Preview ${idx + 1}`} />
                          <button
                            className="remove-image-modern"
                            onClick={() => removeSelectedImage(idx)}
                          >
                            <FaTimes />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* CHAT INPUT */}
                {isNegotiationClosed ? (
                  <div className="message-input-area-modern">
                    <div className="closed-chat-banner">
                      <div className="closed-icon">🔒</div>
                      <div className="closed-text">
                        <strong>This conversation is closed</strong>
                        <span>
                          Another artisan was selected for this project. You
                          can no longer send or receive messages here.
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="message-input-area-modern">
                    {isNegotiationPhase &&
                      !negotiationDetails?.final_agreed_amount &&
                      !hasPendingAgreement && (
                        <button
                          className="submit-agreement-btn-modern"
                          onClick={() => setShowFinalAgreementModal(true)}
                        >
                          <FaHandshake /> Submit Final Agreement
                        </button>
                      )}

                    {isNegotiationActive && (
                      <div className="message-type-selector-modern">
                        <button
                          className={`type-btn-modern ${
                            messageType === 'chat' ? 'active' : ''
                          }`}
                          onClick={() => setMessageType('chat')}
                        >
                          💬 Chat
                        </button>
                        <button
                          className={`type-btn-modern ${
                            messageType === 'milestone' ? 'active' : ''
                          }`}
                          onClick={() => setMessageType('milestone')}
                        >
                          🎯 Milestone
                        </button>
                      </div>
                    )}

                    {isNegotiationActive && messageType === 'milestone' ? (
                      <div className="milestone-inputs-modern">
                        <input
                          type="number"
                          placeholder="Progress %"
                          value={progressPercentage}
                          onChange={(e) =>
                            setProgressPercentage(e.target.value)
                          }
                          className={`progress-input-modern ${
                            isMilestoneComplete ? 'complete' : ''
                          }`}
                          min="0"
                          max="100"
                        />

                        {isMilestoneComplete && (
                          <div className="completion-notice-modern">
                            <FaCheck className="completion-icon" />
                            <span>
                              🎉 This will mark the project as complete and
                              notify the client about final payment!
                            </span>
                          </div>
                        )}

                        <textarea
                          placeholder="Describe the milestone achieved..."
                          value={milestoneNote}
                          onChange={(e) => setMilestoneNote(e.target.value)}
                          className="milestone-textarea-modern"
                          rows={1}
                        />

                        <div className="milestone-actions-modern">
                          <button
                            className="attach-btn-modern"
                            onClick={() => fileInputRef.current?.click()}
                          >
                            <FaImage />
                          </button>

                          <button
                            onClick={sendMessage}
                            disabled={
                              !milestoneNote.trim() ||
                              !progressPercentage ||
                              isSending
                            }
                            className={`milestone-send-btn-modern ${
                              isMilestoneComplete ? 'complete' : ''
                            }`}
                          >
                            {isSending ? <FaClock /> : <FaPaperPlane />}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="input-wrapper-modern">
                        <div className="attach-options-modern">
                          <button
                            className="attach-btn-modern"
                            onClick={() => fileInputRef.current?.click()}
                            title="Upload from gallery"
                          >
                            <FaImage />
                          </button>

                          <button
                            className="camera-btn-modern"
                            onClick={handleCameraCapture}
                            title="Take a photo"
                          >
                            <FaCamera />
                          </button>
                        </div>

                        <input
                          type="text"
                          placeholder={
                            isLoadingChat
                              ? 'Loading conversation...'
                              : 'Type a message...'
                          }
                          value={newMessage}
                          onChange={(e) => setNewMessage(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                              e.preventDefault();
                              sendMessage();
                            }
                          }}
                          className="message-input-modern"
                          disabled={isChatDisabled || isLoadingChat}
                        />

                        <button
                          onClick={sendMessage}
                          disabled={
                            isSending ||
                            isChatDisabled ||
                            isLoadingChat ||
                            (!newMessage.trim() &&
                              selectedImages.length === 0)
                          }
                          className="send-button-modern"
                        >
                          {isSending ? <FaClock /> : <FaPaperPlane />}
                        </button>
                      </div>
                    )}

                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: 'none' }}
                      accept="image/*"
                      multiple
                      onChange={handleImageSelect}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {/* SUBMIT FINAL AGREEMENT MODAL */}
        <Modal
          show={showFinalAgreementModal}
          onHide={() => setShowFinalAgreementModal(false)}
          centered
          className="modal-modern"
        >
          <Modal.Header closeButton>
            <Modal.Title className="modal-title-final-agreement">
              Submit Final Agreement
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="modal-content-modern">
              <p>
                Submit the final agreed price for this project. The client
                will need to accept it.
              </p>
              <div className="input-group-modern">
                <label>Final Agreed Amount (KSh)</label>
                <input
                  type="number"
                  placeholder="Enter final agreed amount"
                  value={finalAgreementAmount}
                  onChange={(e) => setFinalAgreementAmount(e.target.value)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowFinalAgreementModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmitFinalAgreement}
              disabled={!finalAgreementAmount || isSubmittingFinalAgreement}
            >
              {isSubmittingFinalAgreement
                ? 'Submitting...'
                : 'Submit Agreement'}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* EDIT FINAL AGREEMENT MODAL */}
        <Modal
          show={showEditFinalAgreementModal}
          onHide={() => setShowEditFinalAgreementModal(false)}
          centered
          className="modal-modern edit-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FaEdit /> Edit Final Agreement
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="modal-content-modern">
              <p className="warning-text">
                Current pending amount: KSh{' '}
                {Number(
                  negotiationDetails?.pending_final_amount || 0,
                ).toLocaleString()}
              </p>

              <div className="input-group-modern">
                <label>Corrected Amount (KSh)</label>
                <input
                  type="number"
                  placeholder="Enter corrected amount"
                  value={editFinalAgreementAmount}
                  onChange={(e) => setEditFinalAgreementAmount(e.target.value)}
                />
              </div>

              <div className="input-group-modern">
                <label>Reason for correction (Optional)</label>
                <textarea
                  rows="3"
                  placeholder="Explain why you're correcting the amount..."
                  value={editAgreementNote}
                  onChange={(e) => setEditAgreementNote(e.target.value)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowEditFinalAgreementModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleEditFinalAgreement}
              disabled={isEditingFinalAgreement || !editFinalAgreementAmount}
            >
              {isEditingFinalAgreement ? 'Updating...' : 'Update Agreement'}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* IMAGE VIEWER MODAL */}
        <Modal
          show={showImageViewer}
          onHide={() => setShowImageViewer(false)}
          centered
          size="lg"
          className="image-viewer-modal-modern"
        >
          <Modal.Header closeButton>
            <Modal.Title>View Image</Modal.Title>
          </Modal.Header>
          <Modal.Body className="image-viewer-body-modern">
            {selectedImageForView && (
              <img
                src={selectedImageForView}
                alt="Full size"
                className="full-image-modern"
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowImageViewer(false)}
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => window.open(selectedImageForView, '_blank')}
            >
              Download
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default withAuth(ArtisanMessages, 'artisan');